module.exports = __webpack_public_path__ + "img/jbtyk02.242af955.png";